import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { countries } from '../utils/countries';
import { MyContext } from '../context';

const RedirectBasedOnCountry = () => {
  const { country } = useContext(MyContext);

  // console.log('country country country', country);
  //   // Function to fetch country information
  //   const getCountry = () => {
  //     fetch('http://ip-api.com/json')
  //       .then((response) => response.json())
  //       .then((data) => {
  //         const countryCode = countries.find((c) => c.name === data.country);
  //         console.log('country data', data, countryCode);
  //         countrys(countryCode?.value); // e.g., "jp" for Japan
  //       })
  //       .catch((error) => console.error('Error fetching location:', error));
  //   };

  //   useEffect(() => {
  //     getCountry();
  //   }, []);
  console.log('country', country);
  // Optionally show a loading indicator while fetching
  if (!country) return <div>Loading...</div>;

  // Redirect to the country-specific path, e.g., "/jp"
  return <Navigate to={`/${country}`} replace />;
};

export default RedirectBasedOnCountry;
